// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter-active,.page-leave-active{transition:all .5s}.page-enter,.page-leave-active{opacity:0;filter:blur(1rem)}.fade-enter-active,.fade-leave-active{transition-property:opacity;transition-timing-function:ease-in-out;transition-duration:.15s}.fade-enter,.fade-leave-to{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
